import { useEffect, useState } from "react";
import { useUser } from "../context/useUser";
import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";

const url = process.env.REACT_APP_BACKEND_CONNECTION;

export default function DelegateHistory() {
  const { user } = useUser();
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.is_admin) {
      navigate("/unauthorized");
      return;
    }

    async function fetchHistory() {
      try {
        const res = await fetch(`${url}/admin/delegate-history`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });

        const data = await res.json();
        setHistory(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }

    fetchHistory();
  }, [user, navigate]);

  const formatDate = (date) => {
    if (!date) return "—";
    return new Date(date).toLocaleString("fi-FI");
  };

  return (
    <>
      <Header />

      <main className="home-container">

        <div className="profile-section">
          <h1 className="default-title">Delegointihistoria</h1>
          <p className="default-text">
            Kaikki myönnetyt selection delegate -oikeudet.
          </p>
        </div>

        <div className="profile-section">

          {loading ? (
            <p className="default-text">Ladataan...</p>
          ) : history.length === 0 ? (
            <p className="default-text">Ei delegointihistoriaa.</p>
          ) : (

            <table className="admin-history-table">
              <thead>
                <tr>
                  <th>Käyttäjä</th>
                  <th>Taloyhtiö</th>
                  <th>Myöntänyt</th>
                  <th>Myönnetty</th>
                  <th>Voimassa asti</th>
                  <th>Syy</th>
                </tr>
              </thead>

              <tbody>
                {history.map((row, index) => (
                  <tr key={index}>
                    <td>{row.email}</td>
                    <td>{row.company_name}</td>
                    <td>{row.granted_by || "—"}</td>
                    <td>{formatDate(row.granted_at)}</td>
                    <td>{formatDate(row.expires_at)}</td>
                    <td>{row.reason || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>

          )}

        </div>

        <div className="profile-section">
          <button className="btn logout-btn" onClick={() => navigate("/profile")}>
            Takaisin profiiliin
          </button>
        </div>

      </main>

      <Footer />
    </>
  );
}